import styled from '@emotion/styled/macro';

const breakpoints = [576, 576, 768, 992, 1200];
const MEDIA_QUERIES = breakpoints.map(
  (bp, i) => `@media (${!i ? 'max-width' : 'min-width'}: ${bp}px)`
);

const MAX_DESKTOP_WIDTH = '500px';

export const Modal = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.bgColors.primary} !important;
  border: 0 !important;

  box-shadow: ${({ theme }) => theme.input.boxShadow} !important;
  flex-direction: column;
  // inset: 0 !important;

  ${MEDIA_QUERIES[0]} {
    width: 100vw;
    height: 60vh;
    inset: unset !important;
    bottom: 0 !important;
    padding: 10px 15px !important;
    border-radius: 4px 4px 0 0 !important;
  }

  ${MEDIA_QUERIES[1]} {
    // not mobile styles
    width: ${MAX_DESKTOP_WIDTH};
    max-width: ${MAX_DESKTOP_WIDTH};
    ${({ isMobile }) => (isMobile ? 'position: unset !important;' : '')}
    box-shadow: 0 0 20px rgb(0 0 0 / 30%);
  }
`;

export const Overlay = styled.div`
  background-color: transparent !important;
  // worklogs-report/Popup has z-index: 100
  z-index: 101;

  ${MEDIA_QUERIES[1]} {
    display: flex;
    justify-content: center;
    box-shadow: 0 0 20px rgb(0 0 0 / 30%);
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const Title = styled.div`
  font-weight: bold;
  margin: 0 auto;
`;

export const Button = styled.div`
  color: #1a73e8;
  cursor: pointer;
  position: absolute;
  ${({ placement }) => (placement === 'left' ? 'left 0px' : 'right: 0')};
  min-width: 40px;
  text-align: center;
  &:last-child {
    font-weight: 600;
  }
`;

export const Content = styled.div`
  flex: 1;
`;
